import { i18n } from "@/i18n";
import { commonMenuItems } from "./common";
import defaultProfile from "./default";
import type { GameProfile, Menu, ProfileCtx } from "./types";

const { t } = i18n.global;

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

const configSections: ConfigSection[] = [{ component: "ConfSection", props: { name: "basic" } }];

const join = () => {
  window.open(t("ngp/settings/section/starRupture_wiki/link"), "_blank", "noopener,noreferrer");
};

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
  join: {
    buttonTextKey: "ngp/settings/section/starRupture_wiki",
    joinFn: join,
  },
});
